'use client';

import ErrorState from '@/app/(main)/_components/error-state/error-state';
import { Breadcrumb } from '@/components/ui/breadcrumb.component';
import { useErrorBoundaryLogger } from '@/logger/boundary.client';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useErrorBoundaryLogger('boundary.root', error);

  return (
    <>
      <Breadcrumb
        list={[
          {
            label: 'Página inicial',
            href: window.location.origin,
          },
        ]}
      />
      <ErrorState onReset={reset} />
    </>
  );
}
